// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"fd545216","787":"79ab35b3","850":"e548fee6"}[chunkId] + ".chunk.js";
};